import {Injectable} from "@angular/core";
import {DataService} from "../shared/data.service";
import {EMPTY, of} from "rxjs";
import {ApiEndpoints} from "../shared/ApiEndpoints";

@Injectable()
export class ModbusService extends DataService{

  getItems() {
    return this.getRequest(ApiEndpoints.modbusrtu);
  }

  getItem(id) {
    if (!id) {
      return of({error: 'ModbusRTU ID is missing'});
    }
    return this.getRequest(`${ApiEndpoints.modbusrtu}/${id}`)
  }

  saveItem(data) {
    if (data.id) {
      return this.putRequest(ApiEndpoints.modbusrtu, data);
    } else {
      return this.postRequest(ApiEndpoints.modbusrtu, data);
    }
  }

  deleteItem(id) {
    return this.deleteRequest(ApiEndpoints.modbusrtu, id);
  }

  ping(data) {
    if (!data.ip) {
      return of({error: 'Missing IP'});
    }
    return this.postRequest(ApiEndpoints.ping, data)
  }
  query(data) {
    return this.postRequest(ApiEndpoints.query, data);
  }

  getStatus3f(data) {
    return this.postRequest(ApiEndpoints.status3f, data);
  }

  write(ip, register, value, deviceid) {
    return this.postRequest(ApiEndpoints.write, {ip: ip, register: register, value: value, deviceid: deviceid});
  }

  writeMultiple(data) {
    if (!data.ip || !data.list) {
      return of({error: 'Missing list or ID'});
    }
    return this.postRequest(ApiEndpoints.writemultiple, data);
  }

  writeMeasure(data) {
    if (!data.ip || !data.address) {
      return of({error: 'Missing IP or Address'});
    }
    return this.postRequest(ApiEndpoints.writemeasure, data);
  }

  public getModbusRTUMeasures(typeID) {
    return this.getRequest(`${ApiEndpoints.modbusrtuMeasures}/${typeID}`)
  }

  public getLoggerChildren(deviceID) {
    return this.getRequest(`${ApiEndpoints.deviceChildrenWithInfo}/${deviceID}`)
  }

  getModbusRTUFormData() {
    return this.getRequest(ApiEndpoints.modbusrtudata)
  }

  saveAttribute(data) {
    return this.postRequest(ApiEndpoints.postattribute, data)
  }
}
